// import axios from "axios";

// const apiClient = axios.create({
//     baseURL: process.env.REACT_APP_API_BASE_URL || "",
// });

// export default apiClient;


import axios from "axios";
import keycloak from "../../keycloak";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

apiClient.interceptors.request.use(
  async (config) => {

    if (!keycloak.authenticated) {
      await new Promise((resolve) => {
        const interval = setInterval(() => {
          if (keycloak.authenticated) {
            clearInterval(interval);
            resolve();
          }
        }, 50);
      });
    }

    await keycloak.updateToken(30);

    config.headers.Authorization = `Bearer ${keycloak.token}`;

    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;
